import useMixedItemDist from "@hooks/useMixedItemDist";
import { useTranslation } from "react-i18next";
import { getProethicaOrderedEntries } from "../helpers/proethica-module-list";
import {
	type RecommendationCard,
	selectProethicaRecommendationIndices,
	toProethicaRecommendationCard,
} from "../helpers/proethica-recommendations";
import { useProethicaModuleList } from "./useProethicaModuleList";

export const useProethicaRecommendations = (): RecommendationCard[] => {
	const { t } = useTranslation();
	const { data: mixedItemDist } = useMixedItemDist();
	const {
		resolveModuleItems,
		getModuleListItemProps,
		liveStatusFor,
		startingModuleId,
		hasAccess,
		startModule,
	} = useProethicaModuleList();

	const entries = resolveModuleItems(
		getProethicaOrderedEntries(mixedItemDist?.exams),
	);
	if (entries.length === 0) {
		return [];
	}

	const { cardIndices } = selectProethicaRecommendationIndices(
		entries.map((tag) => liveStatusFor(tag) ?? "NOT_STARTED"),
	);

	return cardIndices
		.map((index) => {
			const tag = entries[index];
			const prop = getModuleListItemProps(tag, t);
			return toProethicaRecommendationCard(
				{
					...prop,
					hasAccess,
					disabled: hasAccess ? prop.disabled : false,
				},
				{
					loading: startingModuleId === prop.id,
					onSelect: () => startModule(prop.id),
				},
			);
		})
		.filter((card) => !card.disabled);
};
